export default "__VITE_ASSET__Tku3WWbD__"